import React, { useState, useEffect, useRef } from 'react';
import { Table, Button, Drawer, FormField, FileTokenGroupProps, NonCancelableCustomEvent, SpaceBetween, Box, FileInput } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import { CustomAppLayout } from '../../layout';
import { useRouter } from '../../router';
import { useStore } from '../../store';
import { useGlobalState } from '../../../context/GlobalStateContext';
import { useStoreAdmin } from '../../../context/useStoreAdmin';
import {
  FileDropzone,
  FileTokenGroup,
  FileUpload,
} from '@cloudscape-design/components';
const pageSize = 20;

export const InvoiceNotifyPage = () => {
  const storeAdmin = useStoreAdmin();
  const { JWT, setJWT } = useGlobalState();
  const [helpPanelOpen, setHelpPanelOpen] = useState(false); // Manage HelpPanel state

  const {
    actions: { makeHelpPanelHandler },
  } = useStore();
  const { navigate } = useRouter();

  const [file, setFile] = React.useState<File[]>([]);

  useEffect(() => {
    console.log(file)
    if (file.length!==0 &&file[0].type !== "application/pdf") { 
      console.log(file[0])
      setFile([]);
      alert("El archivo debe ser un PDF");
    }
  }, [file]);
  return (
    <CustomAppLayout

      contentType="form"
      breadcrumbs={<BreadcrumbGroup
        items={[
          { text: 'Inicio', href: '#home' },
          { text: 'Facturación', href: '#invoices' },
          { text: 'Notificar', href: '#create-transcription-job' },
        ]}
        expandAriaLabel="Show path"
        ariaLabel="Breadcrumbs" />}
      content={
        <SpaceBetween size="l">
          <FileDropzone
            onChange={({ detail }) => setFile(detail.value)}
          >
            <SpaceBetween size="xxs" alignItems="center">
              <Box color="inherit">
                Suelte el archivo de comprobante aquí o selecciónelos a continuación (PDF/PNG/JPG)
              </Box>
              <FileInput
                value={file}
                onChange={({ detail }) =>
                  setFile(detail.value)
                }
              >
                Choose files
              </FileInput>
            </SpaceBetween>
          </FileDropzone>
          <FileTokenGroup
            items={file.map(file => ({ file }))}
            onDismiss={({ detail }) =>
              setFile(value =>
                value.filter(
                  (_, index) => index !== detail.fileIndex
                )
              )
            }
            i18nStrings={{
              removeFileAriaLabel: () => "Remove file",
              limitShowFewer: "Show fewer files",
              limitShowMore: "Show more files",
              errorIconAriaLabel: "Error",
              warningIconAriaLabel: "Warning"
            }}
          />
        </SpaceBetween>

      }
    />
  );
};
